<template>
  <div class="mod-org-freezer-week">
    <amis-renderer :schema="schema" />
  </div>
</template>

<script>
import AmisRenderer from '@/components/AmisRenderer';
import schema from './schemas/gen/org-freezer-week.json';

export default {
  name: 'OrgFreezerWeek',
  components: { AmisRenderer },
  data() {
    return {
      schema,
    };
  },
};
</script>

<style lang="scss" scoped></style>
